import { tns } from 'tiny-slider/src/tiny-slider';

class BannerSlider {
    constructor(selector = '.banner-default__slider') {
        this.sliderEl = document.querySelector(selector);
        if (this.sliderEl) {
            this.initSlider();
        }
    }

    initSlider() {
        this.slider = tns({
            container: this.sliderEl,
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayButtonOutput: false,
            controls: true,
            nav: true,
            autoplayTimeout: 20000,
            speed: 600,
            loop: true,
            gutter: 0,
            mode: 'gallery',
            controlsContainer: '.banner-default__slider-controls', 
            prevButton: '.banner-default__slider-prev',       
            nextButton: '.banner-default__slider-next',      
        });
    }
}

export default BannerSlider;
